import React from "react";
import Plot from "react-plotly.js";

// Helper function to calculate Pearson correlation coefficient
const calculateCorrelationMatrix = (data) => {
  const keys = Object.keys(data);
  const numKeys = keys.length;
  const matrix = Array(numKeys)
    .fill(null)
    .map(() => Array(numKeys).fill(0));

  const mean = (arr) => arr.reduce((acc, val) => acc + val, 0) / arr.length;
  const stdDev = (arr) => {
    const mu = mean(arr);
    return Math.sqrt(
      arr.reduce((acc, val) => acc + (val - mu) ** 2, 0) / arr.length
    );
  };

  keys.forEach((keyX, i) => {
    keys.forEach((keyY, j) => {
      const x = data[keyX];
      const y = data[keyY];
      const xMean = mean(x);
      const yMean = mean(y);
      const numerator = x.reduce(
        (acc, val, k) => acc + (val - xMean) * (y[k] - yMean),
        0
      );
      const denominator = x.length * stdDev(x) * stdDev(y);
      matrix[i][j] = denominator ? numerator / denominator : 0;
    });
  });

  return { keys, matrix };
};

const CorrelationGraph = ({ data }) => {
  const { keys, matrix } = calculateCorrelationMatrix(data);

  return (
    <Plot
      data={[
        {
          z: matrix,
          x: keys,
          y: keys,
          type: "heatmap",
          colorscale: "Viridis",
        },
      ]}
      layout={{
        title: "Correlation Matrix",
        xaxis: { title: "Features", automargin: true },
        yaxis: { title: "Features", automargin: true },
        width: 600,
        height: 600,
      }}
      config={{ responsive: true }}
    />
  );
};

export default CorrelationGraph;
